import { render, staticRenderFns } from "./lrDraggable.vue?vue&type=template&id=25a38522"
import script from "./lrDraggable.vue?vue&type=script&lang=js"
export * from "./lrDraggable.vue?vue&type=script&lang=js"
import style0 from "./lrDraggable.vue?vue&type=style&index=0&id=25a38522&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports